/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Form, Col, Spin } from 'antd';
import { JobTitlesSelect } from './JobTitlesSelect';
import { useJobTitlesInstitutionSetting } from '../hooks/useJobTitlesInstitutionSetting';

const FormItem = Form.Item;

export const ConditionalJobTitlesSelect = ({
  getFieldDecorator,
  initialValue,
  formItemLayout,
  colProps,
  ...props
}) => {
  const { config, loading: isLoadingConfig } = useJobTitlesInstitutionSetting();
  if (isLoadingConfig) {
    return (<Col {...colProps}><Spin size="small" /></Col>);
  }

  if (!config.isEnabled) {
    return null;
  }

  return (
    <Col {...colProps}>
        <FormItem {...formItemLayout} label="Profissão/Patente">
          {getFieldDecorator('job_title_id', {
            initialValue,
            rules: [
              {
                required: config.isRequired,
                message: 'Preencha a profissão/patente do paciente.',
              },
            ],
          })(
            <JobTitlesSelect {...props} />,
          )}
        </FormItem>
    </Col>
  );
};
